import { SelectionModel } from "@angular/cdk/collections";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { FlatTreeControl } from "@angular/cdk/tree";
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree";
import { DataNode, FileFlatNode, FileNode, TreeDragDropAuxComponent } from "./tree-drag-drop-aux.component";

@Component({
	selector: "app-tree-drag-drop",
	templateUrl: "./tree-drag-drop.component.html",
	styleUrls: ["./tree-drag-drop.component.scss"]
})
export class TreeDragDropComponent extends TreeDragDropAuxComponent {
	// Variaveis
	@Input() dataTreeControl: FlatTreeControl<FileFlatNode> = new FlatTreeControl<FileFlatNode>(
		this._getLevel,
		this._isExpandable
	);
	treeFlattener: MatTreeFlattener<FileNode, FileFlatNode> = new MatTreeFlattener(
		this.transformer,
		this._getLevel,
		this._isExpandable,
		this._getChildren
	);
	@Input() data: MatTreeFlatDataSource<FileNode, FileFlatNode> = new MatTreeFlatDataSource(
		this.dataTreeControl,
		this.treeFlattener
	);
	expansionModel = new SelectionModel<string>(true);
	dragging = false;
	expandTimeout: any;
	expandDelay = 1000;
	validateDrop = false;
	@Output() nodeMoved = new EventEmitter<DataNode>();

	constructor(protected dialog: MatDialog) {
		super(dialog);
	}

	shouldValidate(event: MatCheckboxChange): void {
		this.validateDrop = event.checked;
	}

	visibleNodes(): FileNode[] {
		const result = [];
		function addExpandedChildren(node: FileNode, expanded: string[]) {
			result.push(node);
			// if (!!node.children && node?.children?.length > 0) {
			if (expanded.includes(node.id)) {
				node.children.map(child => addExpandedChildren(child, expanded));
			}
		}

		this.data.data.forEach(node => {
			addExpandedChildren(node, this.expansionModel.selected);
		});
		return result;
	}

	drop(event: CdkDragDrop<string[]>) {
		if (!event.isPointerOverContainer) return;
		const visibleNodes = this.visibleNodes();
		// deep clone the data source so we can mutate it
		const changedData = JSON.parse(JSON.stringify(this.data.data));
		// recursive find function to find siblings of node
		function findNodeSiblings(arr: Array<any>, id: string): Array<any> {
			let result, subResult;
			arr.forEach((item, i) => {
				if (item.id === id) {
					result = arr;
				} else if (item.children) {
					subResult = findNodeSiblings(item.children, id);
					if (subResult) result = subResult;
				}
			});
			return result;
		}
		const nodeAtDest = visibleNodes[event.currentIndex];
		const newSiblings = findNodeSiblings(changedData, nodeAtDest.id);
		if (!newSiblings) return;
		const insertIndex = newSiblings.findIndex(s => s.id === nodeAtDest.id);
		const node = event.item.data;
		const siblings = findNodeSiblings(changedData, node.id);
		const siblingIndex = siblings.findIndex(n => n.id === node.id);
		const nodeToInsert: FileNode = siblings.splice(siblingIndex, 1)[0];
		if (nodeAtDest.id === nodeToInsert.id) return;
		const nodeAtDestFlatNode = this.dataTreeControl.dataNodes.find(n => nodeAtDest.id === n.id);
		if (this.canMoveNode(nodeAtDestFlatNode, node)) {
			newSiblings.splice(insertIndex, 0, nodeToInsert);
			this.rebuildTreeForData(changedData);
			this.nodeMoved.emit({ canSave: true, nodeToMove: nodeAtDestFlatNode, nodeInDrag: node });
		} else {
			this.nodeMoved.emit({ canSave: false, nodeToMove: null, nodeInDrag: null });
			return;
		}
	}

	dragStart() {
		this.dragging = true;
	}

	dragEnd() {
		this.dragging = false;
	}

	dragHover(node: FileFlatNode) {
		if (this.dragging) {
			clearTimeout(this.expandTimeout);
			this.expandTimeout = setTimeout(() => {
				this.dataTreeControl.expand(node);
			}, this.expandDelay);
		}
	}

	dragHoverEnd() {
		if (this.dragging) {
			clearTimeout(this.expandTimeout);
		}
	}

	public rebuildTreeForData(data: any) {
		// this.data.data = data;
		this.expansionModel.selected.forEach(id => {
			const node = this.dataTreeControl.dataNodes.find(n => n.id === id);
			this.expansionModel.clear();
			// this.dataTreeControl.expand(node);
		});
	}
}
